define('views/content/reports/inactive_resellers',['require','backbone','marionette','datatables','text!templates/content/reports/inactive_resellers.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('datatables');

    var temp = require("text!templates/content/reports/inactive_resellers.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'inactive_resellers',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                inactiveResellersTable: '.inactive-resellers-list'
            };
        },

        onRender: function () {
            this.getReports();
        },

        getReports: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'reports/passive-resellers-reports/',
                method: 'get',
                success: function (response) {
                    _this.showPassiveResellerReports(response.passive_resellers_report);
                }
            });
        },

        showPassiveResellerReports: function (reportData) {
            // Transform report data for datatables format
            var gridData = [];

            var totalRow = {
                last_purchase_days: 0,
                total_v5_count: 0,
                customer_count: 0,
                lead_count: 0
            };

            reportData.forEach(function (reportRow) {
                gridData.push([
                    '<a href="/reports/reseller-sales?reseller_id=' + reportRow.reseller.id + '">' + reportRow.reseller.name + '<a/>',
                    reportRow.reseller.country == 'TR' ? App.polyglot.t('local') : App.polyglot.t('foreign'),
                    reportRow.last_purchase_days,
                    reportRow.total_v5_count,
                    reportRow.customer_count,
                    reportRow.lead_count
                ]);

                if ($.isNumeric(reportRow.last_purchase_days)) {
                    totalRow.last_purchase_days += reportRow.last_purchase_days;
                }
                totalRow.total_v5_count += reportRow.total_v5_count;
                totalRow.customer_count += reportRow.customer_count;
                totalRow.lead_count += reportRow.lead_count;
            });

            // Add total row
            gridData.push([
                App.polyglot.t('total'),
                '',
                totalRow.last_purchase_days,
                totalRow.total_v5_count,
                totalRow.customer_count,
                totalRow.lead_count
            ]);

            if (!this.inactiveResellersDataTable) {
                this.inactiveResellersDataTable = this.ui.inactiveResellersTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    fixedHeader: true,
                    scrollY: App.utils.getContainerHeightWOffset(this.ui.inactiveResellersTable),
                    columns: [
                        { title: App.polyglot.t('reseller') },
                        { title: App.polyglot.t('reseller_country') },
                        { title: App.polyglot.t('days_since_last_purchase'), className: 'text-right' },
                        { title: App.polyglot.t('total_v5_license_count'), className: 'text-right' },
                        { title: App.polyglot.t('total_customer_count'), className: 'text-right' },
                        { title: App.polyglot.t('total_lead_count'), className: 'text-right' }
                    ],
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.inactiveResellersDataTable.clear();
                this.inactiveResellersDataTable.rows.add(gridData);
                this.inactiveResellersDataTable.columns.adjust().draw();
            }
        }

    });
});
